// Loss of Use form config

export const lossOfUseFields = [
    {
        key: 'hire-loss-of-use-information',
        name: 'Hire Loss of Use Information',
        fields: [
            {
                name: 'hire_start_date_1',
                label: 'Hire Period (1)',
                type: 'date_range_start',
                dateRange: {
                    key: 'hire_dates',
                    index: 0,
                    total: 4
                },
                endKey: 'hire_end_date_1',
                validation: {},
                modalValidation: [{ name: 'dateRange' }]
            },
            {
                name: 'hire_end_date_1',
                label: 'Hire End Date (1)',
                type: 'date_range_end',
                startKey: 'hire_start_date_1',
                validation: {}
            },
            {
                name: 'hire_start_date_2',
                label: 'Hire Period (2)',
                type: 'date_range_start',
                dateRange: {
                    key: 'hire_dates',
                    index: 1,
                    total: 4
                },
                endKey: 'hire_end_date_2',
                validation: {},
                modalValidation: [{ name: 'dateRange' }]
            },
            {
                name: 'hire_end_date_2',
                label: 'Hire End Date (2)',
                type: 'date_range_end',
                startKey: 'hire_start_date_2',
                validation: {}
            },
            {
                name: 'hire_start_date_3',
                label: 'Hire Period (3)',
                type: 'date_range_start',
                dateRange: {
                    key: 'hire_dates',
                    index: 2,
                    total: 4
                },
                endKey: 'hire_end_date_3',
                validation: {},
                modalValidation: [{ name: 'dateRange' }]
            },
            {
                name: 'hire_end_date_3',
                label: 'Hire End Date (3)',
                type: 'date_range_end',
                startKey: 'hire_start_date_3',
                validation: {}
            },
            {
                name: 'hire_start_date_4',
                label: 'Hire Period (4)',
                type: 'date_range_start',
                dateRange: {
                    key: 'hire_dates',
                    index: 3,
                    total: 4
                },
                endKey: 'hire_end_date_4',
                validation: {},
                modalValidation: [{ name: 'dateRange' }]
            },
            {
                name: 'hire_end_date_4',
                label: 'Hire End Date (4)',
                type: 'date_range_end',
                startKey: 'hire_start_date_4',
                validation: {}
            }
        ]
    },
    {
        key: 'repair-loss-of-use-information',
        name: 'Repair Loss of Use Information',
        dependsOn: {
            category: 'vehicle_damage',
            key: 'damage_route',
            compareValue: 'repair'
        },
        fields: [
            {
                name: 'date_claim_notified_to_claimant_insurance_company1',
                label: 'Date Claim Notified to Claimant Insurance Company',
                type: 'date',
                validation: {}
            },
            {
                name: 'first_notification_date1',
                label: 'First Notification (NCA) date',
                type: 'date',
                validation: [{ name: 'required' }]
            },
            {
                name: 'date_images_requested1',
                label: 'Date Images Requested',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_images_received1',
                label: 'Date Images Received',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_estimate_requested1',
                label: 'Date Estimate Requested',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_estimate_received1',
                label: 'Date Estimate Received',
                type: 'date',
                validation: {}
            },
            {
                name: 'engineer_instructed_date1',
                label: 'Engineer Instructed Date',
                type: 'date',
                validation: {}
            },
            {
                name: 'engineer_inspection_date1',
                label: 'Engineers Inspection Date',
                type: 'date',
                validation: {}
            },
            {
                name: 'cash_in_lieu_issued1',
                label: 'Cash In Lieu Issued?',
                type: 'text',
                validation: {}
            },
            {
                name: 'engineer_authority_date1',
                label: 'Engineers Authority Date',
                type: 'date',
                validation: {}
            },
            {
                name: 'cho_received_date1',
                label: 'CHO Received date',
                type: 'date',
                validation: {}
            },
            {
                name: 'cho_disclosed_date1',
                label: 'CHO disclosed date',
                type: 'date',
                validation: {}
            },
            {
                name: 'vehicle_book_in_date1',
                label: 'Vehicle Book In Date',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_parts_ordered1',
                label: 'Date Parts Ordered',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_parts_received1',
                label: 'Dates Part Received',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_repair_started1',
                label: 'Date Repair Started',
                type: 'date',
                validation: {}
            },
            {
                name: 'additional_damage_found1',
                label: 'Additional Damage Found?',
                type: 'text',
                validation: {}
            },
            {
                name: 'date_additional_damage_found1',
                label: 'Date Additional Damage Found',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_supplementary_authority_requested1',
                label: 'Date Supplementary Authority Requested',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_supplementary_authority_provided1',
                label: 'Date Supplementary Authority Provided',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_repairs_completed1',
                label: 'Date Repairs Completed',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_vehicle_returned1',
                label: 'Date Vehicle Returned',
                type: 'date',
                validation: {}
            },
            {
                name: 'pre_accident_dmg_identified1',
                label: 'Pre-accident damage identified',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'pre_accident_dmg_date_started1',
                label: 'Pre-accident damage date started',
                type: 'date',
                validation: {}
            },
            {
                name: 'pre_accident_dmg_date_completed1',
                label: 'Pre-accident damage date completed',
                type: 'date',
                validation: {}
            },
            {
                name: 'claimant_delays1',
                label: 'Claimant delays',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'number_of_days_delayed1',
                label: 'Number of days delayed',
                type: 'integer',
                validation: {}
            },
            {
                name: 'rectification_work_identified1',
                label: 'Rectification work identified?',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'rectification_work_date_started1',
                label: 'Rectification work date started',
                type: 'date',
                validation: {}
            },
            {
                name: 'rectification_work_date_complete1',
                label: 'Rectification work date complete',
                type: 'date',
                validation: {}
            },
            {
                name: 'engineer_report_date1',
                label: 'Engineer report date',
                type: 'date',
                validation: {}
            }
        ]
    },
    {
        key: 'total-loss-loss-of-use-information',
        name: 'Total Loss - Loss of Use Information',
        dependsOn: {
            category: 'vehicle_damage',
            key: 'damage_route',
            compareValue: 'total-loss'
        },
        fields: [
            {
                name: 'date_claim_notified_to_claimant_insurance_company2',
                label: 'Date Claim Notified to Claimant Insurance Company',
                type: 'date',
                validation: {}
            },
            {
                name: 'engineer_instructed_date1',
                label: 'Date Engineer Instructed',
                type: 'date',
                validation: {}
            },
            {
                name: 'engineer_inspection_date1',
                label: 'Date Engineer Inspected',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_engineer_report_created2',
                label: 'Date Engineer Report Created',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_engineer_report_received_by_claimant_rep2',
                label: 'Date Engineer Report Received by Claimant Representative',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_engineer_report_received_by_defendant_rep2',
                label: 'Date Engineer Report Received by Defendant Representative',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_pre_accident_valuation_disputed2',
                label: 'Date Pre Accident Valuation Disputed',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_pre_accident_valuation_resolved2',
                label: 'Date Pre Accident Valuation Dispute Resolved',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_pre_accident_value_requested2',
                label: 'Date Pre Accident Value Requested',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_pre_accident_value_issued2',
                label: 'Date Pre Accident Value Issued',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_pre_accident_value_received2',
                label: 'Date Pre Accident Value Received',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_pre_accident_value_banked2',
                label: 'Date Pre Accident Value Banked',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_salvage_instructed2',
                label: 'Date Salvage Instructed',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_salvage_collected2',
                label: 'Date Salvage Collected',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_new_vehicle_order_placed2',
                label: 'Date New Vehicle Order Placed',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_new_vehicle_order_delivered2',
                label: 'Date New Vehicle Delivered',
                type: 'date',
                validation: {}
            }
        ]
    },
    {
        key: 'cash-in-lieu-information',
        name: 'Cash In Lieu Information',
        dependsOn: {
            category: 'vehicle_damage',
            key: 'damage_route',
            compareValue: 'cash-in-lieu'
        },
        fields: [
            {
                name: 'date_cash_in_lieu_requested',
                label: 'Date Cash In Lieu Requested',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_cash_in_lieu_issued',
                label: 'Date Cash in Lieu Issued',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_cash_in_lieu_received',
                label: 'Date Cash In Lieu Received',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_cash_in_lieu_banked',
                label: 'Date Cash In Lieu Banked',
                type: 'date',
                validation: {}
            },
            {
                name: 'vehicle_book_in_date',
                label: 'Vehicle Book In Date',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_parts_ordered',
                label: 'Date Parts Ordered',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_parts_received',
                label: 'Dates Part Received',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_repair_started',
                label: 'Date Repair Started',
                type: 'date',
                validation: {}
            },
            {
                name: 'additional_damage_found2',
                label: 'Additional Damage Found?',
                type: 'text',
                validation: {}
            },
            {
                name: 'date_additional_damage_found2',
                label: 'Date Additional Damage Found',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_supplementary_authority_requested2',
                label: 'Date Supplementary Authority Requested',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_supplementary_authority_provided2',
                label: 'Date Supplementary Authority Provided',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_repairs_completed2',
                label: 'Date Repairs Completed',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_cash_in_lieu_vat_requested',
                label: 'Date Cash In Lieu VAT Requested',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_cash_in_lieu_vat_issued',
                label: 'Date Cash In Lieu Vat Issued',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_cash_in_lieu_vat_received',
                label: 'Date Cash In Lieu VAT Receieved',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_cash_in_lieu_vat_banked',
                label: 'Date Cash In Lieu VAT Banked',
                type: 'date',
                validation: {}
            },
            {
                name: 'date_vehicle_returned2',
                label: 'Date Vehicle Returned',
                type: 'date',
                validation: {}
            },
            {
                name: 'claimant_on_holiday',
                label: 'Claimant on Holiday',
                type: 'boolean',
                validation: {}
            },
            {
                name: 'dates_of_holiday',
                label: 'Dates of Holiday',
                type: 'date',
                validation: {}
            },
            {
                name: 'vehicle_in_use',
                label: 'Vehicle in use',
                type: 'boolean',
                validation: {}
            }
        ]
    }
];
